import * as React from "react";
import AboutCarousel from "./about-carousel";

const About = () => (
  <div className="editorial-page">
    <section className="about-intro">
      <AboutCarousel />
      <p className="eyebrow">Hi, I’m Ruofan.</p>
      <p>
        I’m a frontend developer based in Taiwan, working primarily with React,
        JavaScript, and TypeScript. Recently, I’ve been focusing more on
        JavaScript SDKs, especially placement integrations for Cordova apps. I
        enjoy working through cross-platform constraints and turning complex
        product requirements into experiences that feel straightforward.
      </p>
      <p>
        Before software, I studied international trade and worked outside the
        tech industry. That path shaped how I communicate, learn unfamiliar
        domains, and think about the people on the other side of a screen.
      </p>
      <p>
        Outside work, I enjoy cooking and spending long weekends in the
        mountains. In winter, I like going snowboarding in Japan. I’m also
        starting to learn football and considering getting an Open Water
        diving certification.
      </p>
      <p>
        As an INFJ, I don’t mind putting in extra effort when something
        matters. I enjoy meaningful conversations, though social time can be
        draining, so I recharge best in quieter moments.
      </p>
      <p>
        You can also find me on{" "}
        <a href="https://github.com/ruofanwei">GitHub</a> and{" "}
        <a href="https://www.linkedin.com/in/ruofan-wei-a65922132/">
          LinkedIn
        </a>
        .
      </p>
    </section>
  </div>
);

export default About;
